export interface AvatarColorStyle {
  backgroundColor: string;
  color: string;
}

/** Deterministic avatar colors from a display name — O(n) on name length */
export function getAvatarColorFromName(name: string): AvatarColorStyle {
  const source = name.trim() || 'User';
  let hash = 0;

  for (let index = 0; index < source.length; index += 1) {
    hash = source.charCodeAt(index) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${String(hue)} 58% 42%)`,
    color: '#ffffff',
  };
}
